<div *ngIf="currentStep === 1" class="!mt-[-46px]">
  <div
    class="header h-[55px] flex justify-start items-center pl-[40px] mt-[30px] !bg-[#F1F3F5]"
  >
    <p class="!m-0">
      {{ project_name }} - Pre-Qualification Questionnaire (PQQ)
    </p>
    <p
      class="text-[#21252A] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] !w-[136px] !h-[19px] flex items-center justify-center"
    >
      Project Brief
    </p>
  </div>
  <app-project-brief></app-project-brief>
  <div
    class="!pr-[40px] !mb-[60px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="nextStep()"
      >
        Next
      </button>
    </div>
  </div>
</div>
<div *ngIf="currentStep === 2">
  <app-work-packages></app-work-packages>
</div>
<div *ngIf="currentStep === 3">
  <app-select-companies></app-select-companies>
</div>

<div *ngIf="currentStep === 4">
  <app-submission-guidelines-info
    (closeModalEvent)="handleCloseModal($event)"
  ></app-submission-guidelines-info>
</div>
